import React from 'react';
import { useParams } from 'react-router';
import { getFile } from 'Store/documents/helpers/apiFetchers';
import { useAppSelector } from 'Store/index';
import { getJWTData } from 'Utility/jwtAuthTools';

/**
 * Attachment / file / image displaying component
 * Gets the id of the image from url and fetches it to display
 * Displaying the image is conditional to having the meta data of the image already in the redux store
 * If the jwt patient ID changes, then the image is no longer displayed
 */
const AttachmentWindow = () => {
  const params = useParams();
  const id = params.id;

  const patientId = useAppSelector(s => s.session.data?.patientid);
  const patientPictures = useAppSelector(s => s.documents.files);

  const [patientIdOnMount, _] = React.useState<string | undefined>(patientId);
  const [fileDocument, setFileDocument] = React.useState<IDocumentWithTypeV2<'filestorefile'> | null>(
    patientPictures?.find(pic => pic.fileContentId === id) ?? null,
  );
  const [attachment, setAttachment] = React.useState<Blob | null>(null);
  const [jwt, setjwt] = React.useState<IJWTBody | undefined>(undefined);

  React.useEffect(() => {
    let timer: NodeJS.Timeout | null = setInterval(() => {
      setjwt(getJWTData());
    }, 5000);

    if (id && fileDocument) {
      void getFile(fileDocument._id, fileDocument.fileContentId).then(res => {
        if (res) setAttachment(res);
      });
    }

    return () => {
      // On unmount
      setFileDocument(null);
      setAttachment(null);
      timer && clearInterval(timer);
      timer = null;
    };
  }, []);

  React.useEffect(() => {
    if (jwt && jwt.patientid !== patientIdOnMount) {
      // Set the attachment so that it wont be shown anymore
      setFileDocument(null);
      setAttachment(null);
      // Close the window if possible
      window.close();
    }
  }, [jwt?.patientid]);

  const [toggleScaling, setToggleScaling] = React.useState<'maxWidth' | 'maxHeight'>('maxHeight');

  return (
    <div>
      {/** Maybe its own header component here with zoom controls and all the info that is needed and remove the stuff from big header component */}
      <div style={{ cursor: 'zoom-in' }}>
        {fileDocument?.contentType === 'application/pdf' && attachment ? (
          <iframe style={{ width: '100%', minHeight: '25rem', height: '90vh' }} src={URL.createObjectURL(attachment)} />
        ) : fileDocument && attachment ? (
          <img
            style={{ [toggleScaling]: toggleScaling === 'maxWidth' ? '100vw' : '100vh' }}
            src={URL.createObjectURL(attachment)}
            onClick={() => setToggleScaling(toggleScaling === 'maxWidth' ? 'maxHeight' : 'maxWidth')}
          />
        ) : (
          <></>
        )}
      </div>
    </div>
  );
};

export default AttachmentWindow;
